export const userFeedback = {
    1: {
        qn: 'How easy was it to navigate the application?',
        options: [
            {
                label: '&#128516; Very easy',
                value: 'Very easy',
            },
            {
                label: '&#128578; Easy',
                value: 'Easy',
            },
            {
                label: '&#128528; Neutral',
                value: 'Neutral',
            },
            {
                label: '&#128533; Difficult',
                value: 'Difficult',
            },
            {
                label: '&#128547; Very difficult',
                value: 'Very difficult',
            },
        ],
    },
    2: {
        qn: 'How satisfied are you with the overall design and layout of the app?',
        options: [
            {
                label: '&#128516; Very satisfied',
                value: 'Very satisfied',
            },
            {
                label: '&#128578; Satisfied',
                value: 'Satisfied',
            },
            {
                label: '&#128528; Neutral',
                value: 'Neutral',
            },
            {
                label: '&#128533; Unsatisfied',
                value: 'Unsatisfied',
            },
            {
                label: '&#128547; Very unsatisfied',
                value: 'Very unsatisfied',
            },
        ],
    },
    3: {
        qn: 'How often do you use the app?',
        options: [
            {
                label: 'Daily',
                value: 'Daily',
            },
            {
                label: 'Weekly',
                value: 'Weekly',
            },
            {
                label: 'Monthly',
                value: 'Monthly',
            },
            {
                label: 'Rarely',
                value: 'Rarely',
            },
            {
                label: 'This is my first time',
                value: 'This is my first time',
            },
        ],
    },
    4: {
        qn: 'How easy were the carbon footprint profile questions to answer?',
        options: [
            {
                label: '&#128516; Very easy',
                value: 'Very easy',
            },
            {
                label: '&#128578; Easy',
                value: 'Easy',
            },
            {
                label: '&#128528; Neutral',
                value: 'Neutral',
            },
            {
                label: '&#128533; Difficult',
                value: 'Difficult',
            },
            {
                label: '&#128547; Very difficult',
                value: 'Very difficult',
            },
        ],
    },
    5: {
        qn: 'How easy did you find the carbon reduction challenges to complete?',
        options: [
            {
                label: '&#128516; Very easy',
                value: 'Very easy',
            },
            {
                label: '&#128578; Easy',
                value: 'Easy',
            },
            {
                label: '&#128528; Neutral',
                value: 'Neutral',
            },
            {
                label: '&#128533; Difficult',
                value: 'Difficult',
            },
            {
                label: '&#128547; Very difficult',
                value: 'Very difficult',
            },
        ],
    },
    6: {
        qn: 'How would you rate the rewards available in our rewards store?',
        options: [
            {
                label: '&#128516; Very motivating',
                value: 'Very motivating',
            },
            {
                label: '&#128578; Somewhat motivating',
                value: 'Somewhat motivating',
            },
            {
                label: '&#128528; Neutral',
                value: 'Neutral',
            },
            {
                label: '&#128533; Not very motivating',
                value: 'Not very motivating',
            },
            {
                label: '&#128547; Not motivating at all',
                value: 'Not motivating at all',
            },
        ],
    },
    7: {
        qn: 'Would you recommend this app to others?',
        options: [
            {
                label: '&#128516; Definitely',
                value: 'Definitely',
            },
            {
                label: '&#128578; Probably',
                value: 'Probably',
            },
            {
                label: '&#128528; Not sure',
                value: 'Not sure',
            },
            {
                label: '&#128533; Probably not',
                value: 'Probably not',
            },
            {
                label: '&#128547; Definitely not',
                value: 'Definitely not',
            },
        ],
    },
    8: {
        qn: 'If you have any other feedback or wish to elaborate on any of your answers in the previous questions, please type them below.',
    },
}
